import { HeroComunicado } from "../../components/Comunicado/HeroComunicado";
import { ContenidoComunicadoIndex } from "../../components/Comunicado/ContenidoPagesComunicado";

export const Comunicado = () => {
    return(
        <section style={{marginBottom:'80px'}}>
        
       <HeroComunicado/>
       <ContenidoComunicadoIndex/>
        </section>
    )
}